import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomCheckboxGroup from "../../../components/CustomCheckboxGroup";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import CustomSelect from "../../../components/Select/Select";
import { getDiagnosticTemplateByIdWoLoader } from "../../../redux/reducers/clinicSlice";
import {
  addUpdateTemplateByDiagnosticId,
  createDiagnosticsWoLoader,
  updateDiagnosticsWoLoader,
} from "../../../redux/reducers/petSlice";
import { uploadFilesAndGetUrlWoLoader } from "../../../redux/reducers/planSlice";
import {
  diagnosticTypes,
  diagVetStatusList,
  doneAtList,
  priorityList,
} from "../../../util/dropList";
import { urlToFile } from "../../../util/function";
import FilesWithCloseButton from "../../Hospital/ClinicPetDetails/PatientWorkbook/FilesWithCloseButton";

const ckEditorBuild =
  typeof ClassicEditor?.create === "function"
    ? ClassicEditor
    : ClassicEditor?.default;

const nameExpan = {
  type: "Select Type",
  testName: "Test Name *",
  variant: "Variant *",
  dueDate: "Due Date",
  remarks: "Remarks",
  doneAt: "Done At",
  sampleType: "Sample Type",
  processingTime: "Processing Time",
  modality: "Modality",
  device: "Device",
  priority: "Priority",
  status: "Status",
  collectionTime: "Collection Time *",
  collectedBy: "Performed By *",
};

const initialValues = {
  type: "Lab",
  testName: null,
  variant: null,
  dueDate: new Date(),
  remarks: "",
  files: [],
  price: 0,
  tax: 0,
  sampleCollected: false,
  doneAt: doneAtList?.[0]?.value,
  collectionTime: new Date(),
  priority: "Routine",
  sampleCollected: false,
  collectedBy: null,
  quantity: 1,
};
const initialErrors = {
  type: false,
  dueDate: false,
  remarks: false,
  collectedBy: false,
};
const initialHelpers = { type: "", dueDate: "", remarks: "", collectedBy: "" };
const defaultFile = {
  question: "File Upload",
  questionType: "fileupload",
  required: false,
  answer: ["file"],
  vitalGroupId: null,
  vitalId: null,
  delete: false,
  questionId: null,
};

const DiagnosticAddUpdate = ({
  selectedItem,
  modVisible,
  handleModClose = () => {},
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { appointment } = location.state || {};
  const [diagValues, setDiagValues] = useState(initialValues);
  const [diagnosticsHelpers, setDiagnosticsHelpers] = useState(initialHelpers);
  const [diagnosticsErrors, setDiagnosticsErrors] = useState(initialErrors);
  const [tempSelectedItem, setTempSelectedItem] = useState(null);
  const [tempModVsble, setTempModVsble] = useState(false);
  const [templatevalues, setTemplateValues] = useState({});
  const isEditModal = selectedItem?.diagonosticId ? true : false;
  const {
    diagTemplateById,
    vitalsByIds,
    services: serviceList,
    selectedClinicBranch,
    details: clinicDetails,
  } = useSelector((state) => state?.clinic);
  const clinicVets = useSelector((state) => state?.vet?.vetList?.vets);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const appointmentId = apntDet?.appointment?.appointmentId;
  const role = localStorage.getItem("role");
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    services: clinicServiceList,
    vets: vetList,
    clinic: clinicDataDet,
  } = useMemo(() => {
    if (!mandateDataRaw) {
      return { services: [], vets: [], clinic: {} };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        services: Array.isArray(reqData?.services) ? reqData?.services : [],
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
        clinic: reqData?.clinic ?? {},
      };
    } catch {
      return { services: [], vets: [], clinic: {} };
    }
  }, [mandateDataRaw]);
  const services = clinicServiceList ?? [];
  // role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
  //   ? // apntDet?.appointment?.hospitalId !== clinic?.id
  //     (serviceList?.data ?? [])
  //   : (clinicServiceList ?? []);
  const vets = vetList ?? [];
  // role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
  //   ? (clinicVets ?? [])
  //   : (vetList ?? []);
  const clinicDet = clinicDataDet?.id ? clinicDataDet : clinicDetails;
  const shouldHideAddEditModal =
    selectedItem?.sampleCollected === "Y" &&
    ["pending review", "in progress", "patient review"]?.includes(
      (selectedItem?.status ?? "")?.toLowerCase(),
    );

  const resetDiagForm = () => {
    setDiagValues(initialValues);
    setDiagnosticsErrors(initialErrors);
    setDiagnosticsHelpers(initialHelpers);
  };

  useEffect(() => {
    if (!modVisible) {
      resetDiagForm();
    }
  }, [modVisible]);

  useEffect(() => {
    if (!selectedItem) return;
    if (shouldHideAddEditModal) {
      return handleEnterResult(selectedItem);
    }
    const reqDia = getServiceDetById(selectedItem?.serviceId);

    const [hour, min] =
      selectedItem?.collectionTime?.length > 0
        ? selectedItem?.collectionTime?.split(":")
        : ["00:00"];

    const reqObj = {
      type: selectedItem?.type,
      testName: reqDia
        ? {
            ...reqDia,
            name: reqDia?.serviceName,
            value: reqDia?.serviceName,
            servicePrice: reqDia?.serviceVariants?.[0]?.serviceCharge ?? 0,
            templateId: reqDia?.diagnosticTemplateId ?? null,
          }
        : null,
      remarks: selectedItem?.remark,
      dueDate: selectedItem?.dueDate,
      price: reqDia?.servicePrice ?? reqDia?.sellPrice ?? 0,
      tax: reqDia?.tax ?? 0,
      serviceId: reqDia?.serviceId,
      files: selectedItem?.file?.map((fle) => ({ previewUrl: fle })),
      doneAt: selectedItem?.doneAt,
      sampleCollected: selectedItem?.sampleCollected === "Y",
      priority: selectedItem?.priority,
      status: selectedItem?.status,
      collectionTime: new Date(
        new Date().setHours(hour ? hour : 0, min ? min : 0),
      ),
      templateId: selectedItem?.templateId,
      hsnSacCode: reqDia?.hsnSacCode ?? null,
      collectedBy: null,
      quantity: selectedItem?.quantity ?? 1,
    };
    if (selectedItem?.variantId) {
      reqObj.variantId = selectedItem?.variantId;
      const vnts = getVariantsByServiceId(selectedItem?.serviceId ?? null);
      if (vnts?.length > 0) {
        const reqVar = vnts?.find(
          (vt) => vt?.variantId === selectedItem?.variantId,
        );
        if (reqVar) {
          reqObj.variant = reqVar;
          reqObj.variantId = reqVar?.variantId;
          reqObj.variantName = reqVar?.variantName;
          // reqObj.variant = reqVar?.variantId;
          reqObj.price = reqVar?.servicePrice;
          reqObj.tax = reqVar?.tax ?? 0;
        }
      }
    }
    if (selectedItem?.collectedById) {
      reqObj.collectedBy = {
        name: selectedItem?.collectedByName,
        value: selectedItem?.collectedById,
      };
    }
    setDiagValues(reqObj);
  }, [selectedItem, shouldHideAddEditModal]);

  const handleEnterResult = (selItem) => {
    const reqServ = services?.find(
      (ser) => ser?.serviceId === selItem?.serviceId,
    );
    setTempSelectedItem({
      ...selItem,
      diagnosticTemplateId: reqServ?.diagnosticTemplateId ?? null,
    });
    if (reqServ?.diagnosticTemplateId && selItem?.data?.length > 0) {
      dispatch(
        getDiagnosticTemplateByIdWoLoader(reqServ?.diagnosticTemplateId),
      );
    }
    if (selItem?.data?.length > 0) {
      const vitalIds = [];
      let reqObj = {
        templateId: reqServ?.diagnosticTemplateId,
        resultStatus: selItem?.resultStatus ?? "Final",
        status: selItem?.status ?? "Pending Review",
      };
      selItem?.data?.forEach((li) => {
        if (li?.vitalId) {
          vitalIds.push(li?.vitalId);
          reqObj = {
            ...reqObj,
            [`${li?.question}_Indicator`]:
              li?.[`${li?.question}_Indicator`] ?? null,
          };
        }
        reqObj = {
          ...reqObj,
          [li?.question]:
            li?.questionType === "shortAnswer" ||
            li?.questionType === "paragraph" ||
            li?.questionType === "multipleChoice"
              ? (li?.answer?.[0] ?? "")
              : li?.questionType === "fileupload"
                ? li?.files?.length > 0
                  ? li?.files?.map((fle) => ({ file: null, previewUrl: fle }))
                  : null
                : li?.answer,
        };
      });
      setTemplateValues(reqObj);
      setTempModVsble(true);
      return;
    }
    if (reqServ?.diagnosticTemplateId) {
      dispatch(
        getDiagnosticTemplateByIdWoLoader(reqServ?.diagnosticTemplateId),
      ).then((res) => {
        if (res?.payload) {
          const vitalIds = [];
          let reqObj = {
            templateId: res?.payload?.templateId,
            templateName: res?.payload?.templateName,
            resultStatus: "Final",
            status: "Pending Review",
            type: res?.payload?.type ?? "parameter",
          };
          if (res?.payload?.type === "report") {
            const variant = getServiceDetById(
              selItem?.serviceId,
              selItem?.variantId,
            );
            let reqCont =
              selItem?.content?.length > 0
                ? selItem?.content
                : (res?.payload?.content ?? "");
            if ((variant?.device ?? "")?.length > 0) {
              reqObj = { ...reqObj, device: variant?.device ?? "" };
              // reqCont += `This test was performed using <strong>${variant?.device ?? ""}</strong>`;
            }
            reqObj = { ...reqObj, content: reqCont };
          } else {
            res?.payload?.question?.forEach((li) => {
              reqObj = { ...reqObj, [li?.question]: null };
              if (li?.vitalId) {
                reqObj = { ...reqObj, [`${li?.question}_Indicator`]: null };
                vitalIds.push(li?.vitalId);
              }
            });
          }
          setTemplateValues(reqObj);
          setTempModVsble(true);
        }
      });
    }
    if (!reqServ?.diagnosticTemplateId) {
      const reqObj = {
        templateId: null,
        templateName: null,
        resultStatus: "Final",
        status: "Pending Review",
      };
      setTemplateValues(reqObj);
      setTempModVsble(true);
    }
  };

  const getDiagnostics = () => {
    return (services ?? [])
      ?.filter(
        (dl) =>
          dl?.active === "Y" &&
          dl?.category?.toLowerCase() === diagValues?.type?.toLowerCase(),
      )
      ?.map((dl) => ({
        ...dl,
        name: dl?.serviceName,
        value: dl?.serviceName,
        servicePrice: dl?.serviceVariants?.[0]?.serviceCharge ?? 0,
        templateId: dl?.diagnosticTemplateId ?? null,
      }));
  };

  const getCollectedByList = () => {
    const reqList = (vets ?? [])
      ?.filter(
        (li) =>
          li?.userRole === "ROLE_CLINIC" ||
          li?.userRole === "ROLE_CLINICADMIN" ||
          li?.userRole === "ROLE_RADIOLOGY" ||
          li?.userRole === "ROLE_DOCTOR",
      )
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
    return reqList;
  };

  const getServiceDetById = (servId, vrntId = null) => {
    if (!servId) return null;
    const reqServ = services?.find((ser) => ser?.serviceId === servId);
    if (vrntId) {
      return (
        reqServ?.serviceVariants?.find((vnt) => vnt?.variantId === vrntId) ?? {}
      );
    }
    return reqServ;
  };

  const getVariantsByServiceId = (servId = null) => {
    if (!servId) return [];
    const servDet = getServiceDetById(servId);
    if (servDet) {
      return servDet?.serviceVariants?.map((vnt) => ({
        ...vnt,
        name: vnt?.variantName,
        value: vnt?.variantId,
      }));
    }
    return [];
  };

  const handleChangeValues = (name, value, addObj) => {
    const reqValue =
      typeof value == "object" ? (value?.value ?? "")?.toString() : value;
    const reqObj = { ...diagValues, [name]: value };
    const errObj = {
      ...diagnosticsErrors,
      [name]:
        name === "quantity"
          ? (value ?? "")?.toString()?.length > 0 && Number(value) >= 1
            ? false
            : (value ?? "")?.toString()?.length === 0
              ? true
              : true
          : reqValue?.length > 0 || typeof value === "number"
            ? false
            : name === "dueDate"
              ? false
              : name === "collectionTime"
                ? false
                : name === "collectedBy"
                  ? diagValues?.sampleCollected
                  : true,
    };
    const hlpObj = {
      ...diagnosticsHelpers,
      [name]:
        name === "quantity"
          ? (value ?? "")?.toString()?.length > 0 && Number(value) >= 1
            ? ""
            : (value ?? "")?.toString()?.length === 0
              ? "This field is required"
              : "Value must be grater than or equal to 1"
          : reqValue?.length > 0 || typeof value === "number"
            ? ""
            : name === "dueDate"
              ? ""
              : name === "collectionTime"
                ? ""
                : name === "collectedBy"
                  ? diagValues?.sampleCollected
                    ? "This field is required"
                    : ""
                  : `${name === "type" ? "Type" : nameExpan?.[name]} is required`,
    };
    if (name === "testName") {
      reqObj.price = addObj?.price;
      reqObj.tax = addObj?.tax;
      reqObj.doneAt = addObj.doneAt;
      reqObj.hsnSacCode = addObj?.hsnSacCode;
      reqObj.templateId = addObj?.templateId;
      reqObj.variant = null;
      reqObj.variantId = null;
      errObj.variant = true;
      hlpObj.variant = "Please select a variant";
    }
    if (name === "variant") {
      reqObj.variantId = addObj?.variantId;
      reqObj.variantName = addObj?.variantName;
      const reqVar = getVariantsByServiceId(diagValues?.serviceId)?.find(
        (li) => li?.value === addObj?.variantId,
      );
      reqObj.price = reqVar?.servicePrice ?? 0;
    }
    if (addObj?.serviceId) {
      reqObj.serviceId = addObj?.serviceId;
      // const reqVar = getVariantsByServiceId(addObj?.serviceId);
      // if (reqVar?.[0]?.variantId) {
      //   reqObj.variantId = reqVar?.[0]?.variantId;
      //   reqObj.variantName = reqVar?.[0]?.variantName;
      //   reqObj.variant = reqVar?.[0]?.variantId;
      //   reqObj.price = reqVar?.[0]?.servicePrice ?? 0;
      // }
    }
    if (name === "sampleCollected" && value) {
      reqObj.dueDate = new Date();
      reqObj.collectionTime = new Date();
    }
    setDiagValues(reqObj);
    setDiagnosticsErrors(errObj);
    setDiagnosticsHelpers(hlpObj);
  };

  const onCloseTempMod = (typ = null) => {
    if (typ) {
      resetDiagForm();
      handleModClose(typ);
    }
    setTempModVsble(false);
    setTemplateValues({});
    setTempSelectedItem(null);
  };

  const handleSave = async () => {
    //handle validation
    const err = {};
    const hlp = {};
    if (!diagValues?.testName) {
      err.testName = true;
      hlp.testName = "Test Name is required";
    }
    if (!diagValues?.variant) {
      err.variant = true;
      hlp.variant = "Test Name is required";
    }
    if (!diagValues?.dueDate) {
      err.dueDate = true;
      hlp.dueDate = "Due Date is required";
    }
    if (!diagValues?.quantity || Number(diagValues?.quantity) <= 0) {
      err.quantity = true;
      hlp.dueDate = !diagValues?.quantity
        ? "This field is required"
        : "Value must be grater than or equal to 1";
    }
    if (!diagValues?.collectionTime) {
      err.collectionTime = true;
      hlp.collectionTime = "Collection Time is required";
    }
    if (diagValues?.sampleCollected && !diagValues?.collectedBy?.value) {
      err.collectedBy = true;
      hlp.collectedBy = "This field is required";
    }
    if (Object.keys(err).length > 0) {
      setDiagnosticsErrors({ ...diagnosticsErrors, ...err });
      setDiagnosticsHelpers({ ...diagnosticsHelpers, ...hlp });
      return;
    }
    const form = new FormData();
    if (selectedItem?.appoinment?.appointmentId) {
      form.append("appId", selectedItem?.appoinment?.appointmentId);
    }
    if (
      selectedItem?.paymentId ??
      apntDet?.paymentId ??
      appointment?.appoinment?.appointmentId
    ) {
      form.append(
        "paymentId",
        selectedItem?.paymentId ??
          apntDet?.paymentId ??
          appointment?.appoinment?.appointmentId,
      );
    }
    if (diagValues?.templateId) {
      form.append("templateId", diagValues?.templateId ?? null);
    }
    form.append("type", diagValues?.type);
    form.append("testName", diagValues?.testName?.value);
    form.append("doneAt", diagValues?.doneAt);
    form.append("sampleCollected", diagValues?.sampleCollected);
    form.append("priority", diagValues?.priority);
    form.append("quantity", Number(diagValues?.quantity ?? 1));
    form.append("price", Number(diagValues?.price ?? 0));
    form.append("tax", Number(diagValues?.tax ?? 0));
    form.append(
      "total",
      Number(
        (Number(diagValues?.price ?? 0) + Number(diagValues?.tax ?? 0)) *
          Number(diagValues?.quantity ?? 1),
      ),
    );
    form.append(
      "dueDate",
      moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD"),
    );
    form.append("remark", diagValues?.remarks);
    form.append("hsnSacCode", diagValues?.hsnSacCode ?? null);
    if (diagValues?.serviceId) {
      form.append("serviceId", diagValues?.serviceId);
    }
    if (diagValues?.variant?.variantId ?? diagValues?.variantId) {
      form.append(
        "variantId",
        diagValues?.variant?.variantId ?? diagValues?.variantId,
      );
    }
    if (diagValues?.variantName) {
      form.append("variantName", diagValues?.variantName);
    }
    if (diagValues?.sampleCollected) {
      form.append("addToBilling", true);
    }

    let isFile = false;
    if (
      ["completed", "pending review"].includes(
        (selectedItem?.status ?? "")?.toLowerCase(),
      ) &&
      diagValues?.files?.length === selectedItem?.file?.length
    ) {
      isFile = true;
    }

    if (diagValues?.sampleCollected) {
      if (
        diagValues?.files?.length === 0 ||
        (!diagValues?.files && selectedItem?.file?.length)
      ) {
        form.append("fileDelete", true);
      }
      form.append(
        "collectionTime",
        moment(new Date(diagValues?.collectionTime)).format("HH:mm"),
      );
      form.append("collectedById", diagValues?.collectedBy?.value ?? null);
      form.append("collectedByName", diagValues?.collectedBy?.name ?? null);
    }

    if (!diagValues?.sampleCollected) {
      form.append("status", "Scheduled");
    }
    if (diagValues?.sampleCollected) {
      form.delete("status");
      form.append("status", "In progress");
    }
    if (
      (selectedItem?.status ?? "")?.toLowerCase() === "pending review" &&
      role === "ROLE_DOCTOR"
    ) {
      form.delete("status");
      form.append("status", "Completed");
    }
    if (isFile) {
      form.delete("status");
      form.append("status", selectedItem?.status);
    }

    if (!selectedItem?.diagonosticId && appointmentId) {
      dispatch(
        createDiagnosticsWoLoader({
          appointmentId: appointmentId,
          form,
          formData: true,
        }),
      ).then((res) => {
        if (res?.payload?.status === 200) {
          // callApi();
          resetDiagForm();
          handleModClose("apiSuccess");
          // if (diagValues?.sampleCollected) {
          //   handleEnterResult(res?.payload?.data);
          // }
        }
      });
    } else {
      const metaUpdate = { diagnosticsId: selectedItem?.diagonosticId, form };
      dispatch(updateDiagnosticsWoLoader(metaUpdate)).then((res) => {
        if (res?.payload?.status === 200) {
          // callApi();
          resetDiagForm();
          handleModClose("apiSuccess");
          // if (diagValues?.sampleCollected) {
          //   handleEnterResult(res?.payload?.data);
          // }
        }
      });
    }
  };

  const handleChange = (name, value) => {
    const reqObj = { ...templatevalues, [name]: value };
    if (
      name === "resultStatus" &&
      value !== "Final" &&
      reqObj.status === "Completed"
    ) {
      reqObj.status = "Pending Review";
    }
    setTemplateValues(reqObj);
  };

  const onQuesUploadFile = (ques, e) => {
    const fileList = e?.target?.files;
    let fileLists =
      templatevalues?.[ques]?.length > 0 ? [...templatevalues?.[ques]] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => {
        setTemplateValues({ ...templatevalues, [ques]: fileLists });
      })
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleTempImageRemove = (name, ind) => {
    const reqFiles = templatevalues?.[name]?.filter((fl, i) => i !== ind);
    setTemplateValues({ ...templatevalues, [name]: reqFiles });
  };

  const onSaveTemplateValues = async () => {
    const reqObj = {
      resultStatus: templatevalues?.resultStatus ?? "Final",
      status: templatevalues?.status ?? "Pending Review",
    };
    if (templatevalues?.type === "report") {
      let reqContent = templatevalues?.content ?? "";
      if (
        templatevalues?.device?.length > 0 &&
        templatevalues?.resultStatus === "Final" &&
        templatevalues?.status === "Completed"
      ) {
        reqContent += `This test was performed using <strong>${templatevalues?.device ?? ""}</strong>`;
      }
      reqObj.data = [];
      reqObj.content = reqContent;
    }
    if (templatevalues?.type === "parameter" || !templatevalues?.type) {
      const reqList = await Promise.all(
        [
          defaultFile,
          ...(tempSelectedItem?.diagnosticTemplateId ||
          tempSelectedItem?.templateId
            ? (diagTemplateById?.question ?? [])
            : []),
        ]?.map(async (li) => {
          const reqObj = {
            question: li?.question,
            answer: Array.isArray(templatevalues?.[li?.question])
              ? templatevalues?.[li?.question]
              : [templatevalues?.[li?.question]],
            questionId: li?.questionId ?? null,
            questionType: li?.questionType,
          };
          if (li?.vitalId) {
            reqObj.inputType = li?.inputType ?? null;
            reqObj.vitalGroupId = li?.vitalGroupId;
            reqObj.vitalId = li?.vitalId;
            reqObj.unit = li?.unit ?? null;
            reqObj.lowerRange = li?.lowerRange ?? null;
            reqObj.upperRange = li?.upperRange ?? null;
            reqObj[`${li?.question}_Indicator`] =
              templatevalues?.[`${li?.question}_Indicator`] ?? null;
          }

          if (li?.questionType === "fileupload") {
            delete reqObj.answer;
            const filesList = templatevalues?.[li?.question] || [];
            if (filesList?.length > 0) {
              const form = new FormData();
              // Create an array of promises for all files (convert remote to File)
              const filePromises = filesList?.map(async (fle) => {
                if (fle?.file) {
                  return fle?.file; // Local File
                } else {
                  return await urlToFile(fle?.previewUrl); // Remote File
                }
              });
              // Wait for all file promises to resolve
              const finalFiles = await Promise.all(filePromises);
              // Append all files to the form
              finalFiles?.forEach((file) => {
                form.append("files", file);
              });
              const res = await dispatch(uploadFilesAndGetUrlWoLoader(form));
              if (res?.payload) {
                reqObj.files = res.payload.data?.data;
              }
            }
          }
          return reqObj;
        }),
      );
      reqObj.content = null;
      reqObj.data = reqList;
    }
    dispatch(
      addUpdateTemplateByDiagnosticId({
        diagId: tempSelectedItem?.diagonosticId,
        data: reqObj,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseTempMod("apiSuccess");
      }
    });
  };

  return (
    <>
      <CustomModal
        open={tempModVsble ? false : !shouldHideAddEditModal && modVisible}
        onClose={() => {
          resetDiagForm();
          handleModClose("close");
        }}
        header={isEditModal ? "Edit" : "Add"}
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt15">
              <CustomSelect
                list={diagnosticTypes}
                value={diagValues?.type}
                error={diagnosticsErrors?.type}
                helperText={diagnosticsHelpers?.type}
                name="type"
                label={nameExpan?.["type"]}
                select
                handleChange={(e) => {
                  handleChangeValues("type", e?.target?.value);
                }}
                disabled={isEditModal}
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={getDiagnostics()}
                value={diagValues?.testName}
                name="testName"
                label={nameExpan?.["testName"]}
                search
                handleChange={(e, value) => {
                  handleChangeValues("testName", value, {
                    price: value?.servicePrice ?? 0,
                    tax: value?.tax ?? 0,
                    serviceId: value?.serviceId ?? null,
                    doneAt: value?.doneAt ?? null,
                    hsnSacCode: value?.hsnSacCode ?? null,
                    templateId: value?.templateId ?? null,
                  });
                }}
                error={diagnosticsErrors?.testName}
                helperText={diagnosticsHelpers?.testName}
                disabled={isEditModal}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={getVariantsByServiceId(diagValues?.serviceId ?? null)}
                value={diagValues?.variant}
                name="variant"
                label={nameExpan?.["variant"]}
                search
                handleChange={(e, value) => {
                  handleChangeValues("variant", value, {
                    variantName: value?.variantName,
                    variantId: value?.variantId,
                  });
                }}
                error={diagnosticsErrors?.variant}
                helperText={diagnosticsHelpers?.variant}
                disabled={isEditModal}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                Billable Qty <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="quantity"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("quantity", e?.target?.value)
                }
                value={diagValues?.quantity}
                error={diagnosticsErrors?.quantity}
                helperText={diagnosticsHelpers?.quantity}
                disabled={
                  selectedItem?.sampleCollected === "Y" ||
                  diagValues?.sampleCollected
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                Due Date <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="dueDate"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("dueDate", e?.target?.value)
                }
                value={diagValues?.dueDate}
                error={diagnosticsErrors?.dueDate}
                helperText={diagnosticsHelpers?.dueDate}
                mobileDate
                disabled={
                  selectedItem?.sampleCollected === "Y" ||
                  diagValues?.sampleCollected
                }
              />
            </Grid>
            {diagValues?.type === "Laboratory Test" && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="font-medium fs14 gray7">
                  {nameExpan?.["sampleType"]}
                </div>
                <CustomTextField
                  value={getServiceDetById(diagValues?.serviceId)?.sampleType}
                  fullWidth
                  disabled
                />
              </Grid>
            )}
            {diagValues?.type === "Radiology Test" && (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="font-medium fs14 gray7">
                    {nameExpan?.["modality"]}
                  </div>
                  <CustomTextField
                    value={getServiceDetById(diagValues?.serviceId)?.modality}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="font-medium fs14 gray7">
                    {nameExpan?.["device"]}
                  </div>
                  <CustomTextField
                    value={getServiceDetById(diagValues?.serviceId)?.device}
                    fullWidth
                    disabled
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt15">
              <CustomSelect
                list={doneAtList}
                value={diagValues?.doneAt}
                error={diagnosticsErrors?.doneAt}
                helperText={diagnosticsHelpers?.doneAt}
                name="doneAt"
                label={nameExpan?.["doneAt"]}
                select
                handleChange={(e) => {
                  handleChangeValues("doneAt", e?.target?.value);
                }}
                disabled={selectedItem?.sampleCollected === "Y"}
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                {nameExpan?.["processingTime"]}
              </div>
              <CustomTextField
                value={
                  getServiceDetById(
                    diagValues?.serviceId,
                    diagValues?.variantId ?? null,
                  )?.estimatedDuration ?? ""
                }
                fullWidth
                disabled
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="mtMin10"
            >
              <CustomCheckbox
                label="Study Performed"
                // {
                //   diagValues?.type === "Lab" ? "Sample Collected" : "Test Taken"
                // }
                checked={diagValues?.sampleCollected}
                onChange={() =>
                  handleChangeValues(
                    "sampleCollected",
                    !diagValues?.sampleCollected,
                  )
                }
                disabled={selectedItem?.sampleCollected === "Y"}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={priorityList}
                value={diagValues?.priority}
                error={diagnosticsErrors?.priority}
                helperText={diagnosticsHelpers?.priority}
                name="priority"
                label={nameExpan?.["priority"]}
                select
                handleChange={(e) => {
                  handleChangeValues("priority", e?.target?.value);
                }}
                disabled={isEditModal}
                mandatoryField
              />
            </Grid>
            {diagValues?.sampleCollected && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <CustomTextField
                    name="collectionTime"
                    fullWidth
                    mobileTime
                    handleChange={(e) =>
                      handleChangeValues("collectionTime", e?.target?.value)
                    }
                    value={diagValues?.collectionTime}
                    error={diagnosticsErrors?.collectionTime}
                    helperText={diagnosticsHelpers?.collectionTime}
                    is12HourFomat={false}
                    label={nameExpan["collectionTime"]}
                    disabled={selectedItem?.sampleCollected === "Y"}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <CustomSelect
                    list={getCollectedByList()}
                    value={diagValues?.collectedBy}
                    name="collectedBy"
                    label={nameExpan?.["collectedBy"]}
                    search
                    handleChange={(e, value) => {
                      handleChangeValues("collectedBy", value);
                    }}
                    error={diagnosticsErrors?.collectedBy}
                    helperText={diagnosticsHelpers?.collectedBy}
                    disabled={selectedItem?.sampleCollected === "Y"}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                label={nameExpan?.["remarks"]}
                placeholder="Remarks"
                name="remarks"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("remarks", e?.target?.value)
                }
                value={diagValues?.remarks}
                error={diagnosticsErrors?.remarks}
                helperText={diagnosticsHelpers?.remarks}
                multiline
                disabled={
                  (selectedItem?.status ?? "")?.toLowerCase() === "completed"
                    ? true
                    : false
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-center">
                <div>
                  <CustomButton
                    text={
                      (selectedItem?.status ?? "")?.toLowerCase() ===
                        "pending review" && role === "ROLE_DOCTOR"
                        ? "Reviewed"
                        : "Submit"
                    }
                    smallBtn
                    onClick={handleSave}
                    disabled={
                      (selectedItem?.status ?? "")?.toLowerCase() ===
                      "completed"
                      //  ||
                      // (selectedItem?.status?.toLowerCase() ===
                      //   "pending review" &&
                      //   role !== "ROLE_DOCTOR")
                    }
                    grayBtn={
                      (selectedItem?.status ?? "")?.toLowerCase() ===
                      "completed"
                    }
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={tempModVsble}
        onClose={() => onCloseTempMod("close")}
        header={tempSelectedItem?.testName}
        modal
        modalWidth={70}
        headerBold
      >
        <div className="scroll-80vh ph20">
          <div className="flex-row-ali-cen">
            <Typography className="txt-semi-bold fs16 black">Type:</Typography>
            <Typography className="font-medium fs16 black3 ml5">
              {tempSelectedItem?.type}
            </Typography>
            <Typography className="txt-semi-bold fs16 black ml10">
              Variant:
            </Typography>
            <Typography className="font-medium fs16 black3 ml5">
              {
                getServiceDetById(
                  tempSelectedItem?.serviceId,
                  tempSelectedItem?.variantId,
                )?.variantName
              }
            </Typography>
            <Typography className="txt-semi-bold fs16 black ml10">
              Performed By:
            </Typography>
            <Typography className="font-medium fs16 black3 ml5">
              {tempSelectedItem?.collectedByName}
            </Typography>
          </div>
          <div className="blue-hor-split mv10" />
          {templatevalues?.type === "report" ? (
            ckEditorBuild ? (
              <div className="mv20">
                <CKEditor
                  editor={ckEditorBuild}
                  disableWatchdog
                  data={templatevalues?.content}
                  onChange={(event, editor) => {
                    const value = editor?.getData();
                    handleChange("content", value);
                  }}
                />
              </div>
            ) : null
          ) : (
            [
              defaultFile,
              ...(tempSelectedItem?.diagnosticTemplateId ||
              tempSelectedItem?.templateId
                ? (diagTemplateById?.question ?? [])
                : []),
            ]?.map((ques, i) => {
              let answers = ques?.answer;
              let matchObj = null;
              let questionType = ques?.questionType;

              return (
                <div key={`${ques?.questionId} ${i}`} className="mv5">
                  <div className="flex-row-between">
                    <div
                      className={
                        ques?.vitalId && ques?.inputType === "Numeric"
                          ? "w48Per"
                          : "w100Per"
                      }
                    >
                      <Typography className="font-medium fs16 black">
                        {ques?.question}{" "}
                      </Typography>
                      {matchObj?.unit?.length > 0 && (
                        <Typography className="font-medium fs14 gray3">
                          {matchObj?.unit}
                        </Typography>
                      )}
                      <div className="mv5">
                        {questionType === "shortAnswer" ||
                        questionType === "paragraph" ? (
                          <CustomTextField
                            fullWidth
                            value={templatevalues?.[ques?.question]}
                            multiline={ques?.questionType === "paragraph"}
                            handleChange={(e) =>
                              handleChange(ques?.question, e?.target?.value)
                            }
                          />
                        ) : questionType === "multipleChoice" ? (
                          <CustomCheckbox
                            radios={answers?.map((rd) => ({
                              label: rd,
                              value: rd,
                            }))}
                            defaultValue={templatevalues?.[ques?.question]}
                            radio
                            onChange={(e) => {
                              handleChange(ques?.question, e?.target?.value);
                            }}
                            isRow={false}
                          />
                        ) : questionType === "checkboxes" ? (
                          <div className="ml10">
                            <CustomCheckboxGroup
                              list={answers?.map((li) => ({
                                label: li,
                                value: li,
                              }))}
                              value={templatevalues?.[ques?.question] ?? []}
                              onChange={(e) => {
                                handleChange(ques?.question, e);
                              }}
                            />
                          </div>
                        ) : questionType === "dropdown" ? (
                          <CustomSelect
                            list={answers?.map((li) => ({
                              name: li,
                              value: li,
                            }))}
                            value={templatevalues?.[ques?.question]}
                            name={ques?.question}
                            // label={`${ques?.question}__Indicator`}
                            select
                            handleChange={(e) =>
                              handleChange(ques?.question, e?.target?.value)
                            }
                          />
                        ) : (
                          <div>
                            {templatevalues?.[ques?.question]?.length > 0 ? (
                              <div className="mt20">
                                <FilesWithCloseButton
                                  files={templatevalues?.[ques?.question]}
                                  onClickFile={(i, file) =>
                                    handleTempImageRemove(ques?.question, i)
                                  }
                                />
                              </div>
                            ) : null}
                            <div className="mt20">
                              <CustomUpload
                                onUploadFile={(e) =>
                                  onQuesUploadFile(ques?.question, e)
                                }
                                multipleNew
                                multiFiles
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {ques?.vitalId && ques?.inputType === "Numeric" ? (
                      <div className="w48Per">
                        <Typography className="font-medium fs16 black">
                          Indicator
                        </Typography>
                        {matchObj?.unit?.length > 0 && (
                          <Typography className="font-medium fs14 gray3">
                            Ref: {matchObj?.lowerRange ?? ""} -{" "}
                            {matchObj?.upperRange ?? ""}
                          </Typography>
                        )}
                        <div className="mv5">
                          <CustomSelect
                            list={[
                              { name: "Normal", value: "Normal" },
                              { name: "Cretical", value: "Cretical" },
                            ]}
                            value={
                              templatevalues?.[`${ques?.question}_Indicator`]
                            }
                            name={`${ques?.question}_Indicator`}
                            // label={`${ques?.question}__Indicator`}
                            select
                            handleChange={(e) =>
                              handleChange(
                                `${ques?.question}_Indicator`,
                                e?.target?.value,
                              )
                            }
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })
          )}
          <Typography className="font-medium fs16 black">
            Result Status
          </Typography>
          <div>
            <CustomSelect
              list={[
                { name: "Preliminary", value: "Preliminary" },
                { name: "Final", value: "Final" },
              ]}
              value={templatevalues?.resultStatus}
              name="resultStatus"
              select
              handleChange={(e) =>
                handleChange("resultStatus", e?.target?.value)
              }
            />
          </div>

          <Typography className="font-medium fs16 black mt10">
            Status
          </Typography>
          <div>
            <CustomSelect
              list={
                templatevalues?.resultStatus === "Final"
                  ? diagVetStatusList
                  : diagVetStatusList.filter(
                      (item) => item.value !== "Completed",
                    )
              }
              value={templatevalues?.status}
              name="status"
              select
              handleChange={(e) => handleChange("status", e?.target?.value)}
            />
          </div>

          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Save"
                smallBtn
                onClick={onSaveTemplateValues}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default DiagnosticAddUpdate;
